var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAlertSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.50082 10.5012L8.56514 13.5656L14.3895 7.74122L13.5408 6.89258L8.56514 11.8683L6.34946 9.65258L5.50082 10.5012Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.405273 10.0771C0.405273 15.3705 4.71183 19.677 10.0053 19.677C15.2987 19.677 19.6053 15.3705 19.6053 10.0771C19.6053 4.78361 15.2987 0.477051 10.0053 0.477051C4.71183 0.477051 0.405273 4.78361 0.405273 10.0771ZM1.60527 10.0771C1.60527 5.44553 5.37327 1.67705 10.0053 1.67705C14.6368 1.67705 18.4053 5.44505 18.4053 10.0771C18.4053 14.7091 14.6373 18.477 10.0053 18.477C5.37327 18.477 1.60527 14.7086 1.60527 10.0771Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAlertSuccess);
export default __webpack_public_path__ + "static/media/icon-alert-success.252f9b24e022249d19db97df44dbb447.svg";
export { ForwardRef as ReactComponent };